module.exports = __webpack_public_path__ + "assets/img/logAudit-module6-4.8848d2d6.jpg";